var map = {
  "./shape-star-aquamarine-gradient.png": "62707",
  "./shape-star-aquamarine-light.png": "41351",
  "./shape-star-aquamarine.png": "12640",
  "./shape-star-blue-gradient.png": "7483",
  "./shape-star-blue-light.png": "19118",
  "./shape-star-blue.png": "89977",
  "./shape-star-cyan-gradient.png": "32306",
  "./shape-star-cyan-light.png": "55690",
  "./shape-star-cyan.png": "93792",
  "./shape-star-green-gradient.png": "56046",
  "./shape-star-green-light.png": "48587",
  "./shape-star-green.png": "87466",
  "./shape-star-grey100.png": "17008",
  "./shape-star-grey1000.png": "15806",
  "./shape-star-grey200.png": "937",
  "./shape-star-grey25.png": "58648",
  "./shape-star-grey300.png": "92272",
  "./shape-star-grey400.png": "58203",
  "./shape-star-grey50.png": "50152",
  "./shape-star-grey500.png": "14417",
  "./shape-star-grey600.png": "36945",
  "./shape-star-grey700.png": "80145",
  "./shape-star-grey800.png": "80015",
  "./shape-star-grey900.png": "60806",
  "./shape-star-indigo-gradient.png": "38131",
  "./shape-star-indigo-light.png": "8470",
  "./shape-star-indigo.png": "45050",
  "./shape-star-lime-gradient.png": "38987",
  "./shape-star-lime-light.png": "54869",
  "./shape-star-lime.png": "68620",
  "./shape-star-magenta-gradient.png": "19362",
  "./shape-star-magenta-light.png": "81214",
  "./shape-star-magenta.png": "44772",
  "./shape-star-navy-gradient.png": "66235",
  "./shape-star-navy-light.png": "41796",
  "./shape-star-navy.png": "55968",
  "./shape-star-orange-gradient.png": "50038",
  "./shape-star-orange-light.png": "80653",
  "./shape-star-orange.png": "28228",
  "./shape-star-purple-gradient.png": "5257",
  "./shape-star-purple-light.png": "55953",
  "./shape-star-purple.png": "26567",
  "./shape-star-red-gradient.png": "18802",
  "./shape-star-red-light.png": "70342",
  "./shape-star-red.png": "70738",
  "./shape-star-yellow-gradient.png": "28702",
  "./shape-star-yellow-light.png": "42758",
  "./shape-star-yellow.png": "16852"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56237;
